import React from 'react';
import { observer } from 'mobx-react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { withRouter } from 'react-router';

import BasicLayout from '@layouts/BasicLayout';
import * as NavConfig from '@common/NavConfig';
import login_user_store from '@src/Store/LoginUser/LoginUserStore';
import user_store, { pagination_store, filter_store, ItemStore } from '@store/User/UserList/UserStore';

@withRouter
@observer
class ViewsDashBoard extends React.Component {
  constructor() {
    super();
    this.state = { someKey: 'someValue' };
  }

  generateRouteList = (match_path) => {
    let result = [];
    NavConfig.getNavNodeByMatchPath(match_path).children.forEach((child) => {
      if(child.redirect && Array.isArray(child.children)) {
        result.push(
          (
            <Redirect key={child.path} exact to={child.redirect} from={child.path} />
          )
        );
        let nest_result = this.generateRouteList(child.path);
        // console.log('generateRouteList: ', nest_result);
        result = [...result, ...nest_result];
      } else {
        let { authority, icon, name, ...res } = child;

        result.push(
          (
            <Route key={child.path} {...res}/>
          )
        )

      }
    });
    return result;
  }

  render() {
    let route_list = this.generateRouteList(this.props.match.path);

    return (
      <BasicLayout>
        <Switch>
          {
            route_list
          }
          {
            // <Route component={() => (
            //   <div>NoMatch</div>
            // )}/>
            <Route render={() => {
              return (
                <Redirect
                  to={{
                    // pathname: `/proxy/user-list/${ItemStore.Type_Normal}/${login_user_store.id}`,
                    pathname: `/my-summary/${login_user_store.id}/${login_user_store.pet_name}`,
                  }}/>
              )
            }}/>
          }
        </Switch>
      </BasicLayout>
    );
  }

  componentDidMount() {
    this.setState({ someKey: 'otherValue' });
  }
}

export default ViewsDashBoard;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/ViewsDashboard.jsx